import { render, staticRenderFns } from "./addListDialog.vue?vue&type=template&id=15fbf6fc&scoped=true"
import script from "./addListDialog.vue?vue&type=script&lang=js"
export * from "./addListDialog.vue?vue&type=script&lang=js"
import style0 from "./addListDialog.vue?vue&type=style&index=0&id=15fbf6fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fbf6fc",
  null
  
)

export default component.exports